import gsap from 'gsap';
import Viewport from '../core/Viewport';

export default el => {
    let closeBtn = el.querySelector('button[data-close]');
    let focusedElementBeforeOpen;

    el.hidden = false;

    try {
        focusedElementBeforeOpen = document.activeElement;
        Viewport.lockTabbing(el, closeBtn);
    } catch (error) {
        console.error(error);
    }

    gsap.fromTo(el, {
        opacity: 0
    }, {
        opacity: 1,
        duration: 0.3
    });

    let closeHandler;

    const onWindowKeyUp = e => {
        if ((e.key || '') !== 'Escape') {
            return;
        }

        closeHandler();
    };

    const close = () => {
        console.log('close modal', { closeBtn });

        try {
            Viewport.releaseTabbing(focusedElementBeforeOpen);
        } catch (error) {
            console.error(error);
        }

        closeBtn.removeEventListener('click', close);
        window.removeEventListener('keyup', onWindowKeyUp);

        closeBtn = null;
        focusedElementBeforeOpen = null;

        gsap.to(el, {
            opacity: 0,
            duration: 0.3,
            onComplete() {
                el.hidden = true;
            }
        });
    };

    closeHandler = close;

    closeBtn.addEventListener('click', close);
    window.addEventListener('keyup', onWindowKeyUp);
};
